import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { ApiService } from '../../services/api.service';
import { ProgramModel } from '../../models';
import { ApiEnvironmentService } from 'src/app/app-initializer/api-environment/api-environment.service';
import { nrError } from '../../helpers/newrelic.helper';

/**
 * Resolves program data before the program route activates.
 * Returns null if program not found; component handles navigation to /404.
 */
@Injectable({ providedIn: 'root' })
export class ProgramResolver implements Resolve<ProgramModel | null> {
  constructor(
    private apiService: ApiService,
    private apiEnvironmentService: ApiEnvironmentService,
  ) {}

  resolve(
    route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot,
  ): Observable<ProgramModel | null> {
    const programNumber = route.paramMap.get('pgmNbr');
    if (!programNumber) return of(null);

    const baseUrl = this.apiEnvironmentService.baseAdminUrl || '';
    return this.apiService.getProgram(programNumber).pipe(
      map((json: any) => {
        const program = ProgramModel.parseProgram(json, baseUrl);
        if (!program || !program.programNumber) return null;
        return program;
      }),
      catchError((err) => {
        nrError(err, { context: 'program_resolver', programNumber });
        return of(null);
      }),
    );
  }
}
